import { html, css } from 'lit-element';
import { TmnConfirmationToolBase } from '@trumedianetworks/tmn-core-components/src/tmn-tool-base';

class ConfirmDeleteDeviceBtn extends TmnConfirmationToolBase {
    constructor() {
        super();
        this.disabled = false;
        this.buttonColor = 'error';
        this.controlType = 'icon-button';
        this.actionLabel = 'Delete';
        this.itemType = 'device';
    }

    static get styles() {
        return [
            super.styles,
            css`
                tmn-icon-button {
                    color: var(--app-error-color);
                }
            `,
        ];
    }

    static get properties() {
        return {
            disabled: {
                type: Boolean,
            },
            eventData: {
                type: Object,
            },
            actionLabel: {
                type: String,
            },
            itemType: {
                type: String,
            },
        };
    }

    getButtonLabel() {
        return html`${this.actionLabel} selected`;
    }

    getToolTitle() {
        return html`${this.actionLabel} selected`;
    }

    getConfirmationLabel() {
        const { actionLabel, itemType } = this;
        return `Are you sure want to ${actionLabel.toLowerCase()} this ${itemType}?`;
    }

    renderIconButton() {
        return html`<tmn-icon-button
            title="Remove device"
            @click=${this._toggleDialog}
            .eventData=${this.eventData}
            variant="text">
            <tmn-icon iconvariant="outlined" icon="delete"></tmn-icon
        ></tmn-icon-button>`;
    }

    _handleConfirm(e) {
        // could pass in actions as an alternative
        const { eventData = {} } = this;
        this._toggleDialog();
        const event = new CustomEvent('delete-device-confirmed', {
            detail: {
                ...eventData,
            },
        });
        this.dispatchEvent(event);
    }
}

window.customElements.define('confirm-delete-device-btn', ConfirmDeleteDeviceBtn);
